import { render } from "./record2.vue?vue&type=template&id=2d8bf0af&scoped=true"
import script from "./record2.vue?vue&type=script&lang=js"
export * from "./record2.vue?vue&type=script&lang=js"

import "./record2.vue?vue&type=style&index=0&id=2d8bf0af&scoped=true&lang=css"
import "./record2.vue?vue&type=style&index=1&id=2d8bf0af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d8bf0af"

export default script